import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleRiskListPage" */
	'pages/vehicle/Vehicle/VehicleRiskListPage'));

export default [{ component, exact: true, path: '/vehicles_risks' }];